<template>
  <div class="container">
    <BaseFrame
      :idText = 'idText'
      :id="id"
      :infosArr="infosArr"
      @cancel='$router.push(-1)'
      submitText="完成"
      @submit='submit()'
      saveText='保存'
      clearText=""
      @save='save()'
      logText="操作日志"
      @hanldeLog="handleLog"
      :logData="logData"
    >
      <div slot="content">
        <lk-form
          :model="recallForm.saleRecallPlan"
          label-position="right"
          :label-width="130"
          ref="recallForm.saleRecallPlan"
        >
          <div class="cardContainer">
            <lk-card title="召回计划信息">
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="召回机构:">
                    <span>{{recallForm.saleRecallPlan.recallAgency}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="召回原因:">
                    <span v-html="brRecallReason"></span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="召回凭据:">
                    <Uploader v-if="recallForm.saleRecallPlan.recallImgUrl" style="width:250px" :able='false' v-model.trim="recallForm.saleRecallPlan.recallImgUrl"></Uploader>
                    <span v-else ></span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col>
                  <lk-form-item label="召回商品:">
                    <div class="goodsTable">
                      <lk-table border :columns='columns' :data='tableData'></lk-table>
                    </div>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>

  </div>
</template>

<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import afterSale from '../../services/afterSale';
import utils from '../../libs/utils';
import Uploader from '../../components/Uploader.vue';
export default {
  name: 'MedicineRecallRecord',
  data() {
    return {
      idText: '召回单号',
      id: '',
      infosArr: [],
      showClear: false,
      revokedFailedReasonError: true,
      logData: [],
      page: 1,
      size: 10,
      count: 0,
      params: {
        recallPlanId: '',
      },
      // recallPlanStatus: '',  // 召回审批状态
      recallForm: {
        saleRecallPlan: {
          id: '', // 召回计划id
          recallReason: '', // 召回原因
          recallAgency: '', // 召回机构
          drugApprovedNames: '', // 商品名称
          recallImgUrl: '',//商品图片
          drugSerialCode: '', // 商品编码
          specifications: '', // 规格
          licenseNumber: '', // 批准文号
          manufacturer: '', // 生产企业
          supplierStoreId: '', // 供应商id
        },
        saleRecallPlanInfoVOS: [],
      },
      // saleRecallPlanInfo:{
      //   revokedType: '',   //召回来源类型
      //   recallItemId: '',   // 召回来源id
      //   revokingCount: '',  // 应召回数量
      //   revokedCount: '', // 已召回数量
      //   revokedFailedCount: '', // 未召回数量
      //   revokedFailedReason: '', //	 未召回原因
      //   recallPlanId: '',   // 召回计划id
      // },
      columns: [
        {
          title: '序号', key: 'index', width: 80, type: 'index',
        },
        {
          title: '单据来源',
          key: 'revokedType',
          minWidth: 116,
          render: (h, params) => {
            if (params.row.revokedType === 1) {
              return h('span', '库存商品');
            } if (params.row.revokedType === 2) {
              return h('span', '销售订单');
            } if (params.row.revokedType === 3) {
              return h('span', '调拨单');
            }
            return h('span', '-');
          },
        },
        { title: '单号', key: 'recallItemId', minWidth: 116 },
        { title: '商品名称', key: 'drugApprovedNames', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
        // {title: '数量', key: 'itemCount', minWidth: 116},
        {
          title: '应召回数', key: 'revokingCount', minWidth: 116, fixed: 'right',
        },
        {
          title: '实际召回数',
          key: 'revokedCount',
          minWidth: 116,
          fixed: 'right',
          render: (h, params) => {
            if (this.$route.name === 'medicineRecallRecordCheck') {
              return h('span', params.row.revokedCount);
            }
            return h('lk-input-number', {
              props: {
                clearable: true,
                min: 0,
                precision: 2,
                max: params.row.revokingCount,
                value: params.row.revokedCount,
                'active-change': false,
                placeholder: '请输入',
              },
              on: {
                'on-change': (e) => {
                  // this.getErrorInfoTip(e)
                  this.tableData[params.row._index].revokedCount = e;
                  // if (parseInt(e) >= 0) {
                  //   this.tableData[params.row._index].revokedCount = Math.floor(e);
                  // }
                },
              },
            });
          },
        },
        {
          title: '未召回数',
          key: 'revokedFailedCount',
          minWidth: 116,
          fixed: 'right',
          render: (h, params) => {
            this.tableData[params.row._index].revokedFailedCount = parseFloat(params.row.revokingCount - params.row.revokedCount);
            return h('span', parseFloat(params.row.revokingCount - params.row.revokedCount).toFixed(2));
          },
        },
        {
          title: '备注',
          key: 'revokedFailedReason',
          minWidth: 116,
          fixed: 'right',
          render: (h, params) => {
            if (this.$route.name === 'medicineRecallRecordCheck') {
              return h('span', params.row.revokedFailedReason);
            }
            return h('lk-input', {
              props: {
                clearable: true,
                value: params.row.revokedFailedReason,
                placeholder: '请输入',
              },
              on: {
                'on-blur': (e) => {
                  this.tableData[params.row._index].revokedFailedReason = e.target.value;
                },
              },
            });
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    // getErrorInfoTip(val){
    //   console.log("9999-----------999999"+val)
    //   if(parseInt(val) <= 0){
    //     console.log("不能小于0")
    //   }
    // },
    save() {
      console.log('-----------');
      this.tableExchangeObject();
      console.log(this.recallForm);

      afterSale.recallPlanRecord(this.recallForm).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('保存成功');
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    submit() {
      // recallPlanDone
      this.tableExchangeObject();
      this.getErrorInfo();
      // console.log('---------');
      // console.log(this.revokedFailedReasonError);
      if (this.revokedFailedReasonError) {
        afterSale.recallPlanDone(this.recallForm).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('保存成功');
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        this.$Message.error('请填写未召回备注!');
      }
    },
    getErrorInfo() {
      this.revokedFailedReasonError = true;
      this.tableData.forEach((item) => {
        // console.log(`${item.revokedCount}----${item.revokedFailedCount}-----999${item.revokedFailedReason}`);
        // if(item.revokedCount <= 0){
        //   this.revokedCountError = false;
        // }
        if (item.revokedFailedCount > 0 && item.revokedFailedReason === '') {
          // console.log('执行');
          this.revokedFailedReasonError = false;
          // console.log(this.revokedFailedReasonError);
        }
      });
    },
    getInfos(id) {
      return new Promise((resolve) => {
        afterSale.recallPlanInfo({ id }).then((res) => {
          // console.log(res);
          if (res.data.status === 200) {
            const temp = Object.assign({}, res.data.data);

            this.id = temp.saleRecallPlan.recallPlanCode;
            let statusText = '';
            if (temp.saleRecallPlan.recallPlanStatus === 1) {
              statusText = '草稿';
            } else if (temp.saleRecallPlan.recallPlanStatus === 2) {
              statusText = '审批中';
            } else if (temp.saleRecallPlan.recallPlanStatus === 3) {
              statusText = '审批通过';
            } else if (temp.saleRecallPlan.recallPlanStatus === 4) {
              statusText = '驳回';
            } else if (temp.saleRecallPlan.recallPlanStatus === 5) {
              statusText = '已完成';
            }
            this.infosArr.push(
              { name: '召回门店:', value: temp.saleRecallPlan.storeName },
              { name: '召回时间:', value: utils.exchangeTimeToSecond(temp.saleRecallPlan.modifiedTime) },
              { name: '召回人:', value: temp.saleRecallPlan.createUserName },
              { name: '单据状态:', value: statusText },
            );

            // this.recallPlanStatus = temp.saleRecallPlan.recallPlanStatus;  // 召回状态
            this.recallForm.saleRecallPlan = {
              id: temp.saleRecallPlan.id, // 召回计划id
              recallReason: temp.saleRecallPlan.recallReason, // 召回原因
              recallAgency: temp.saleRecallPlan.recallAgency, // 召回机构
              recallImgUrl: temp.saleRecallPlan.recallImgUrl, //商品图片
              drugApprovedNames: temp.saleRecallPlan.drugApprovedNames, // 商品名称
              drugSerialCode: temp.saleRecallPlan.drugSerialCode, // 商品编码
              specifications: temp.saleRecallPlan.specifications, // 规格
              licenseNumber: temp.saleRecallPlan.licenseNumber, // 批准文号
              manufacturer: temp.saleRecallPlan.manufacturer, // 生产企业
              supplierStoreId: temp.saleRecallPlan.supplierStoreId, // 供应商id
            };
            // this.recallForm.saleRecallPlanInfoVOS = temp.saleRecallPlanInfoVOS;

            if (temp.saleRecallPlanInfoVOS && temp.saleRecallPlanInfoVOS.length > 0) {
              temp.saleRecallPlanInfoVOS.forEach((item) => {
                this.tableData.push({
                  id: item.saleRecallPlanInfo.id,
                  drugApprovedNames: temp.saleRecallPlan.drugApprovedNames, // 商品名称
                  goodsBatchNumber: temp.saleRecallPlan.licenseNumber, // 批号
                  revokingCount: item.saleRecallPlanInfo.revokingCount, // 应召唤数
                  recallItemId: item.saleRecallPlanInfo.recallItemId, // 单号
                  manufacturer: temp.saleRecallPlan.manufacturer, //  生产厂家
                  revokedType: item.saleRecallPlanInfo.revokedType, // 单据来源
                  specifications: temp.saleRecallPlan.specifications, // 规格
                  revokedCount: item.saleRecallPlanInfo.revokedCount !== undefined ? item.saleRecallPlanInfo.revokedCount : 0, // 实际召回数
                  revokedFailedCount: item.saleRecallPlanInfo.revokedFailedCount !== undefined ? item.saleRecallPlanInfo.revokedFailedCount : 0, // 未召回数
                  revokedFailedReason: item.saleRecallPlanInfo.revokedFailedReason !== undefined ? item.saleRecallPlanInfo.revokedFailedReason : '',
                  recallPlanId: item.saleRecallPlanInfo.recallPlanId,
                });
              });
            }
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    tableExchangeObject() {
      this.recallForm.saleRecallPlanInfoVOS = [];
      this.tableData.forEach((item) => {
        this.recallForm.saleRecallPlanInfoVOS.push({
          'saleRecallPlanInfo.id': item.id,
          'saleRecallPlanInfo.revokedType': item.revokedType,
          'saleRecallPlanInfo.recallItemId': item.recallItemId,
          'saleRecallPlanInfo.drugApprovedNames': item.drugApprovedNames,
          'saleRecallPlanInfo.specifications': item.specifications,
          'saleRecallPlanInfo.goodsBatchNumber': item.goodsBatchNumber,
          'saleRecallPlanInfo.manufacturer': item.manufacturer,
          'saleRecallPlanInfo.revokingCount': item.revokingCount,
          'saleRecallPlanInfo.revokedCount': item.revokedCount,
          'saleRecallPlanInfo.revokedFailedCount': item.revokedFailedCount,
          'saleRecallPlanInfo.revokedFailedReason': item.revokedFailedReason,
        });
      });
    },
    handleLog() {
      // console.log('日志');
      // console.log(this.tableData[0].recallPlanId);

      // this.params.page = this.page;
      // this.params.size = this.size;
      // this.params.recallPlanId = this.tableData[0].recallPlanId;
      // const params = Object.assign({}, this.params);
      afterSale.recallPlanOperationList({ recallPlanId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.logData = res.data.data;

          // this.logData = res.data.data.list;
          console.log(this.logData);
        }
      });
      // recallOperateLog
    },
  },
  created() {
    console.log(this.$route.name);
    this.getInfos(this.$route.params.id).then(() => {

    });
  },
  components: {
    BaseFrame,
    Uploader
  },
  computed: {
    brRecallReason() {
      const reg = new RegExp('\\n', 'g');// g,表示全部替换。
      return this.recallForm.saleRecallPlan.recallReason.replace(reg, '<br/>');
    },
  },
};
</script>

<style scoped>

</style>
